import HttpClient from "@/common/boot/HttpClient"

const listarMetodos = async ({ commit }, payload) => {

  commit('CARREGANDO', true);

  await HttpClient.get('/integracao/ctrl-metodos', payload).then(response => {
      commit('LISTAR_DADOS', response.data.data);
      return response;
  });

  commit('CARREGANDO', false);
}

export {
  listarMetodos
}